import Zoomist from "zoomist";

$(function () {
    if ($(".js-gallery-slider").length > 0) {
        const countZoom = $(".zoomist-container").length;
        let zoomContainer = [];

        for (let i = 0; i < countZoom; i++) {
            zoomContainer[i] = new Zoomist(`.zoomist-container-${i}`, {
                draggable: true,
                wheelable: true,
                pinchable: true,
                maxScale: 4,
                minScale: 1,
                bounds: true,
                slider: true,
                zoomer: true,
            });

            // zoomContainer[i].on("zoom", (zoomist, scale) => {
            //     console.log(scale);
            //     if (scale == 1) {
            //         zoomist.reset();
            //     }
            // });
        }

        const myCarousel = document.getElementById("carouselGalleryFade");
        myCarousel.addEventListener("slide.bs.carousel", (event) => {
            console.log("slide event!");
            for (let i = 0; i < countZoom; i++) {
                zoomContainer[i].reset();
            }
            console.log(event.to);

            if ($('.js-carousel-pagination-current').length > 0) {
                $('.js-carousel-pagination-current').text(event.to + 1);
            }
        });
    }
});
